import axios from 'axios';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { checkAutoLogin } from './AuthService';
import { useEffect } from 'react';
import { HOSTNAME, MAUURL } from '../constant';
import Swal from 'sweetalert2';

const axiosInstance = axios.create({
    baseURL: HOSTNAME,
    withCredentials: true,
    withXSRFToken: true,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    proxy: {
        protocol: 'https',
        host: MAUURL,
        // hostname: '127.0.0.1' // Takes precedence over 'host' if both are defined
        // port: 9000,
        // auth: {
        //   username: 'mikeymike',
        //   password: 'rapunz3l'
        // }
    }
});

axiosInstance.interceptors.request.use((config) => {
    config.headers = config.headers || {};
    // Ambil UUID pengguna yang sudah login untuk header X-Tenant-ID
    try {
        const storedUuid = localStorage.getItem('uuid') || localStorage.getItem('user_uuid');
        if (storedUuid && !config.headers['X-Tenant-ID']) {
            config.headers['X-Tenant-ID'] = storedUuid;
        } else if (!config.headers['X-Tenant-ID']) {
            const userDetails = localStorage.getItem('userDetails');
            if (userDetails) {
                const parsed = JSON.parse(userDetails);
                const uuid = parsed?.uuid || parsed?.data?.uuid;
                if (uuid) {
                    config.headers['X-Tenant-ID'] = uuid;
                }
            }
        }
    } catch (e) {
        // silent parse error
    }

    if (config.url && config.url.includes('storage.schoolmedia.id')) {
        config.headers['Content-Type'] = 'application/json';
    }
    console.log('config', config);
    return config;
});



axiosInstance.interceptors.response.use((response) => {
    console.log('response instance : ', response);
    return response;
}, error => {
    console.log('error instance : ', error?.response);
    const message = error?.response?.data?.message || error?.message || 'Terjadi kesalahan sistem';
    Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: message,
    })
    return Promise.reject(error);
})

export default axiosInstance;
